import { PureComponent } from "react";
import './LoadingScreen.css';

class LoadingScreen extends PureComponent {
    render(){
        return (     
		<div className='loading-screen-container'>
			<div className='loading-screen-pulse-container'>
				<div className='loading-screen-pulse'></div>
			</div>
			<div className='loading-screen-logo-container'>
				<svg width="84" height="84" viewBox="0 0 84 84" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<rect x="0.2" y="0.2" width="83.6" height="83.6" rx="12.8" fill="#1B1C1A" stroke="#727272" strokeWidth="0.4"/>
					<g clipPath="url(#clip0_1_83)">
						<path d="M20.9988 37.6459H16.7326V48.4864H14.2844V37.6459H10V35.7124H20.9988V37.6459Z" fill="white"/>
						<path d="M29.9787 44.1976H22.4573C22.5122 46.0212 23.6723 47.0429 25.3197 47.0429C26.6656 47.0429 27.5822 46.2588 27.8258 45.2015H29.9025C29.6041 47.5181 27.4695 48.7773 25.3197 48.7773C22.2716 48.7773 20.2679 47.0607 20.2679 43.7402C20.2679 40.6752 22.232 38.7773 25.207 38.7773C28.1821 38.7773 29.9787 40.8742 29.9787 43.467V44.1976ZM22.4573 42.9383H27.7314C27.6187 41.4236 26.626 40.5118 25.1126 40.5118C23.6906 40.5118 22.567 41.3315 22.4573 42.9383Z" fill="white"/>
						<path d="M31.8849 35.7124H34.1687V48.4864H31.8849V35.7124Z" fill="white"/>
						<path d="M47.2503 39.3001L44.4854 41.9969L47.2533 44.6966L50.0182 41.9999L47.2503 39.3001ZM52.64 44.5571L50.0182 41.9999L47.2533 44.6966L54.7381 51.9969L57.503 49.3001L52.637 44.5541L52.64 44.5571ZM54.7259 32.0088L47.2503 39.3001L50.0182 41.9999L57.4939 34.7085L54.7259 32.0088Z" fill="#59C2F0"/>
						<path d="M39.7625 32L36.9976 34.6968L44.4823 42L37.0067 49.2914L39.7747 51.9911L50.0183 42.003L39.7625 32Z" fill="white"/>
						<path d="M75 51.9999V48.1835H64.4123V32.0059H60.4963V51.9999H75Z" fill="white"/>
					</g>
					<defs>
						<clipPath id="clip0_1_83">
							<rect width="65" height="20" fill="white" transform="translate(10 32)"/>
						</clipPath>
					</defs>
				</svg>
			</div>
		</div>
        );
    }
}

export default (LoadingScreen);